import EventDetailStandings from '@/screens/EventDetailStandings';

export default function PrivateTabsOrganizationScheduleScheduleBEventIdStandingsRoute() {
  return <EventDetailStandings />;
}
